angular
.module('app')
.component('educationTeachingDetailsComponent', {
  templateUrl: 'app/components/education-teaching-details/education-teaching-details.tmpl.html',
  controller: function ($http, appConfig, $stateParams, $location, anchorSmoothScroll, localStorageService, $state, cartService, educationService) {
    const vm = this;

    vm.init = function () {
      educationService.getTeachingMaterialDetails($stateParams.id).then(function (res) {
        if (res && res.data) {
          vm.pageData = res.data.teaching_material;
          vm.pageData.date = res.data.teaching_material.published_date;
          vm.pageData.image_url =  res.data.teaching_material.image_url && res.data.teaching_material.image_url;
          vm.pageData.price = res.data.teaching_material.price ? res.data.teaching_material.price : 0
        }
      });
    };

    vm.more = function () {
      vm.pageData.analitic = _.chunk(angular.copy(vm.pageData.analitics), 3);
    };

    vm.gotoElement = function (eID) {
      $location.hash('prefooter');
      anchorSmoothScroll.scrollTo(eID);
      $location.hash('');
    };

    vm.downloadExcerpt = function () {
      $state.go('download-excerpt', {type: 'teachingMaterial', id: vm.pageData.id});
      localStorageService.set('link', vm.pageData.excerpts[0].url);
    };

    vm.addProduct = function () {
      const params = {
        user_cart: { 
          cartable_id: vm.pageData.id,
          description: vm.pageData.header,
          cartable_type: "TeachingMaterial",
          quantity: 1
        } 
      }

      cartService.createCart(params).then(function (res) {
        if(res.status === 200) {
          $state.go('cart-page', {wayBack: 'educationTeachingMaterials'});
        }
      });
    };

    vm.getUser = function () {
      return localStorageService.get('currentUser').id === undefined;
    };
  }
});
